// formatPercentage.js
export default function formatPercentage(numerator, denominator) {
    if (!denominator || isNaN(numerator) || isNaN(denominator)) {
        return "0.0";
    }
    return ((numerator / denominator) * 100).toFixed(1);
}
